import { PERMISSION_MENU_TREE } from "../../../utils/permissions";

export const LIMIT_OPTIONS = [10, 20, 50];

export const AUDIT_ACTION_OPTIONS = [
  { value: "CREATE", label: "Creó" },
  { value: "UPDATE", label: "Editó" },
  { value: "DELETE", label: "Eliminó" },
];

const AUDIT_ACTION_LABELS = Object.fromEntries(
  AUDIT_ACTION_OPTIONS.map((option) => [option.value, option.label])
);

function flattenMenuLeaves(nodes) {
  return nodes.flatMap((node) =>
    node.children ? flattenMenuLeaves(node.children) : [node]
  );
}

export const AUDIT_MENU_OPTIONS = flattenMenuLeaves(PERMISSION_MENU_TREE).map(
  (node) => ({ value: node.key, label: node.label })
);

const AUDIT_MENU_LABELS = Object.fromEntries(
  AUDIT_MENU_OPTIONS.map((option) => [option.value, option.label])
);

export function getMenuLabel(menuKey) {
  return AUDIT_MENU_LABELS[menuKey] || menuKey || "—";
}

export function getActionLabel(action) {
  return AUDIT_ACTION_LABELS[action] || action || "—";
}

export function getActionBadgeClass(styles, action) {
  if (action === "CREATE") {
    return styles.CreateBadge;
  }

  if (action === "DELETE") {
    return styles.DeleteBadge;
  }

  return styles.UpdateBadge;
}

export function getAuditLogsResponse(result) {
  const response = result?.logs || result?.response || result || {};

  if (Array.isArray(response.docs)) {
    return response;
  }

  if (Array.isArray(response)) {
    return {
      docs: response,
      totalDocs: response.length,
      totalPages: 1,
      page: 1,
      limit: response.length,
    };
  }

  return {
    docs: [],
    totalDocs: 0,
    totalPages: 1,
    page: 1,
    limit: 10,
  };
}

export function getAuditUserName(log) {
  const user = log?.user;

  if (!user) {
    return "—";
  }

  const fullName = `${user.firstname || ""} ${user.lastname || ""}`.trim();

  return fullName || user.email || "—";
}

export function formatDateTime(value) {
  if (!value) {
    return "—";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "—";
  }

  return date.toLocaleString("es-GT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatChangeValue(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  if (typeof value === "boolean") {
    return value ? "Sí" : "No";
  }

  if (Array.isArray(value)) {
    return value.length ? value.join(", ") : "—";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
}

export function formatChangeSummary(change) {
  return `${change.label || change.field}: ${formatChangeValue(
    change.before
  )} → ${formatChangeValue(change.after)}`;
}
